module.exports = __webpack_public_path__ + "img/10.15f2e963.png";